import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./layouts/WarehouseLayout.css";
import Login from "./pages/Login";
import AuthenticatedLayout from "./layouts/AuthenticatedLayout";
import Home from "./pages/Home";
import Reportistica from "./pages/Reportistica";
import Automazione from "./pages/Automazione";
import Produttivita from "./pages/Produttivita";
import AIAgents from "./pages/AIAgents";
import Applicativi from "./pages/Applicativi";
import Upload from "./pages/Upload";
import PercorsiNonMappati from "./pages/PercorsiNonMappati";
import TransazioniRavvicinate from "./pages/TransazioniRavvicinate";
import PosizioniNonCoerenti from "./pages/PosizioniNonCoerenti";
import SvuotamentoCampane from "./pages/SvuotamentoCampane";
import InfoPercorsi from "./pages/InfoPercorsi";
import MancatoLogin from "./pages/MancatoLogin";
import ManutenzioneAutomezzi from "./pages/ManutenzioneAutomezzi";
import MezziDisponibiliLive from "./pages/MezziDisponibiliLive";
import PersonaleDisponibileLive from "./pages/PersonaleDisponibileLive";
import GestioneUtenti from "./pages/GestioneUtenti";
import MaterialiGrafici from "./pages/Chatbot/MaterialiGrafici";
import AlertSvuotamentiCampane from "./pages/AlertSvuotamentiCampane";
import KgTeoriciRaccolti from "./pages/KgTeoriciRaccolti";
import PianificazioneAbiti from "./pages/PianificazioneAbiti";
import UploadReportHera from "./pages/UploadReportHera/UploadReportHera";
import ReportOrariMagazziniere from "./pages/ReportOrariMagazziniere/ReportOrariMagazziniere";
import OperazioniHr from "./pages/OperazioniHr/OperazioniHr";
import HrGenerale from "./pages/HrGenerale/HrGenerale";
import HrDettaglio from "./pages/HrDettaglio/HrDettaglio";
import HrCosti from "./pages/HrCosti/HrCosti";
import OperazioniAutomezzi from "./pages/OperazioniAutomezzi/OperazioniAutomezzi";
import Spazzato from "./pages/Spazzato/Spazzato";
import TransAutomezzi from "./pages/TransAutomezzi/TransAutomezzi";
import PianoFerie from "./pages/PianoFerie";
import GestioneMagazzino from "./pages/GestioneMagazzino";
import GestioneOrdini from "./pages/GestioneOrdini";
import SvuotamentiSettAtersir from "./pages/SvuotamentiSettAtersir";
import Ambiente from "./pages/Ambiente/Ambiente";
import Admin from "./pages/Admin/Admin";
import RagPage from "./pages/Rag/RagPage";
import AgenteControlloRendicontazioni from "./pages/AgenteControlloRendicontazioni";
import SimulatoreCostiDipendenti from "./pages/SimulatoreCostiDipendenti/SimulatoreCostiDipendenti";
import RegistrazioniCall from "./pages/RegistrazioniCall";
import ReportSapCapisquadra from "./pages/ReportSapCapisquadra/ReportSapCapisquadra";
import ReportGiacenzaMagazzino from "./pages/ReportGiacenzaMagazzino/ReportGiacenzaMagazzino";
import GestionePercorsi from "./pages/GestionePercorsi/GestionePercorsi";
import GestionePresenze from "./pages/GestionePresenze/GestionePresenze";
import GestioneDipendentiChiamata from "./pages/GestioneDipendentiChiamata/GestioneDipendentiChiamata";
import AnomalieGps from "./pages/AnomalieGps/AnomalieGps";
import Chatbot from "./pages/Chatbot/Chatbot";
import ReportPubblico from "./pages/ReportPubblico/ReportPubblico";
import { getUserAllowedRoutes } from "./config/cardRegistry";
import { savePostLoginRedirect } from "./utils/postLoginRedirect";
import ErrorBoundary from "./components/ErrorBoundary";

// Versione app: cambia ad ogni build, forza il re-login degli utenti
const APP_VERSION = process.env.REACT_APP_BUILD_VERSION || "__DEV__";

// Mappa route → componente per il rendering dinamico
const ROUTE_COMPONENTS = {
    "/transazioni-ravvicinate": TransazioniRavvicinate,
    "/transazioni-non-coerenti": PosizioniNonCoerenti,
    "/piano-ferie": PianoFerie,
    "/gestione-magazzino": GestioneMagazzino,
    "/gestione-ordini": GestioneOrdini,
    "/upload-report-hera": UploadReportHera,
    "/report-orari-magazziniere": ReportOrariMagazziniere,
    "/operazioni-hr": OperazioniHr,
    "/operazioni-automezzi": OperazioniAutomezzi,
    "/spazzato": Spazzato,
    "/trans-automezzi": TransAutomezzi,
    "/hr-generale": HrGenerale,
    "/hr-dettaglio": HrDettaglio,
    "/hr-costi": HrCosti,
    "/mancato-login": MancatoLogin,
    "/percorsi-non-mappati": PercorsiNonMappati,
    "/svuotamento-campane": SvuotamentoCampane,
    "/info-percorsi": InfoPercorsi,
    "/pianificazione-abiti": PianificazioneAbiti,
    "/alert-svuotamenti-campane": AlertSvuotamentiCampane,
    "/manutenzione-automezzi": ManutenzioneAutomezzi,
    "/mezzi-disponibili-live": MezziDisponibiliLive,
    "/personale-disponibile-live": PersonaleDisponibileLive,
    "/kg-teorici-raccolti": KgTeoriciRaccolti,
    "/svuotamenti-settimanali-atersir": SvuotamentiSettAtersir,
    "/ambiente": Ambiente,
    "/admin": Admin,
    "/rag": RagPage,
    "/agente-controllo-rendicontazioni": AgenteControlloRendicontazioni,
    "/report-sap-capisquadra": ReportSapCapisquadra,
    "/report-giacenza-magazzino": ReportGiacenzaMagazzino,
    "/gestione-dipendenti-chiamata": GestioneDipendentiChiamata,
    "/anomalie-gps": AnomalieGps,
    "/simulatore-costi-dipendenti": SimulatoreCostiDipendenti,
    "/gestione-percorsi": GestionePercorsi,
    "/gestione-presenze": GestionePresenze,
    "/registrazioni-call": RegistrazioniCall,
    "/chatbot-ai": Chatbot,

};

const WarehouseLayout = ({ onLogout }) => {
    const userName = localStorage.getItem("username") || "Utente";

    return (
        <div className="warehouse-layout">
            <div className="warehouse-header">
                <div className="warehouse-header-left">
                    <img src={require("./assets/lf_logo.png")} alt="LF23 Logo" className="warehouse-logo" />
                    <span className="warehouse-brand">LF23</span>
                </div>
                <div className="warehouse-header-right">
                    <span className="warehouse-username">{userName}</span>
                    <button className="warehouse-logout-btn" onClick={onLogout} title="Logout">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        Logout
                    </button>
                </div>
            </div>
            <div className="warehouse-content">
                <GestioneMagazzino isWarehouseMode />
            </div>
        </div>
    );
};

// Layout standalone per il ruolo `gestore_automezzi`: stesso pattern di WarehouseLayout
// (header minimale + logout, niente sidebar) ma incapsula MezziDisponibiliLive.
// La pagina rileva la prop isStandaloneMode per nascondere elementi che non hanno
// senso fuori dal layout autenticato standard (es. bottone "Indietro" verso /produttivita).
const AutomezziLayout = ({ onLogout }) => {
    const userName = localStorage.getItem("username") || "Utente";

    return (
        <div className="warehouse-layout">
            <div className="warehouse-header">
                <div className="warehouse-header-left">
                    <img src={require("./assets/lf_logo.png")} alt="LF23 Logo" className="warehouse-logo" />
                    <span className="warehouse-brand">LF23</span>
                </div>
                <div className="warehouse-header-right">
                    <span className="warehouse-username">{userName}</span>
                    <button className="warehouse-logout-btn" onClick={onLogout} title="Logout">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        Logout
                    </button>
                </div>
            </div>
            <div className="warehouse-content">
                <MezziDisponibiliLive isStandaloneMode />
            </div>
        </div>
    );
};

// Confine d'errore delle pagine autenticate: si resetta al cambio di route, così
// un errore di render in una sezione non lascia la schermata bianca su tutta l'app.
const PageErrorBoundary = ({ children }) => {
    const { pathname } = useLocation();
    return <ErrorBoundary resetKey={pathname}>{children}</ErrorBoundary>;
};

// Dirotta al login memorizzando la pagina richiesta, così dopo l'autenticazione
// l'utente ci torna invece di finire sulla home (es. scorciatoia iOS su /chatbot-ai).
const RedirectToLogin = () => {
    const { pathname, search } = useLocation();
    savePostLoginRedirect(pathname + search);
    return <Navigate to="/login" replace />;
};

const App = () => {
    // Force logout se la versione dell'app è cambiata (nuovo deploy)
    const storedVersion = localStorage.getItem("appVersion");
    if (APP_VERSION !== "__DEV__" && storedVersion !== APP_VERSION) {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("username");
        localStorage.removeItem("permissions");
        localStorage.removeItem("allowedRoutes");
        localStorage.removeItem("tagMap");
        localStorage.setItem("appVersion", APP_VERSION);
    }

    const [token, setToken] = useState(localStorage.getItem("token") || "");
    const role = localStorage.getItem("role");
    const allowedRoutes = getUserAllowedRoutes();

    // Link pubblico dei report condivisibili (/r/<token>): e' l'unica pagina che vive
    // FUORI dal login, per clienti ed enti esterni. Si decide qui, prima del gate sul
    // token, cosi' chi non e' loggato non finisce su /login e chi lo e' non vede la
    // sidebar. Il backend risponde solo se il report e' pubblicato.
    if (/^\/r\/[A-Za-z0-9_-]+\/?$/.test(window.location.pathname)) {
        return (
            <Router>
                <Routes>
                    <Route path="/r/:token" element={<ReportPubblico />} />
                </Routes>
            </Router>
        );
    }
    const isAdmin = role === "admin" || role === "superadmin";

    const handleLogout = () => {
        setToken("");
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("username");
        localStorage.removeItem("permissions");
        localStorage.removeItem("allowedRoutes");
        localStorage.removeItem("tagMap");
    };


    const getDefaultRouteForRole = (role) => {
        if (role === "gestore_magazzino") return "/magazzino";
        if (role === "gestore_automezzi") return "/mezzi-disponibili-live";
        return "/";
    };


    if (!token) {
        return (
            <Router>
                <Routes>
                    <Route path="/login" element={
                        <Login setToken={(t) => {
                            setToken(t.token);
                            localStorage.setItem("token", t.token);
                            localStorage.setItem("role", t.role);
                            localStorage.setItem("username", t.username);
                            localStorage.setItem("permissions", JSON.stringify(t.permissions || []));
                            localStorage.setItem("allowedRoutes", JSON.stringify(t.allowedRoutes || []));
                            localStorage.setItem("tagMap", JSON.stringify(t.tagMap || {}));
                            localStorage.setItem("appVersion", APP_VERSION);
                        }} />
                    } />
                    {/*<Route path="/register" element={<Registration />} />*/}
                    <Route path="*" element={<RedirectToLogin />} />
                </Routes>
            </Router>
        );
    }

    // Layout dedicato per gestore_magazzino: solo pagina magazzino, no sidebar
    if (role === "gestore_magazzino") {
        return (
            <Router>
                <Routes>
                    <Route path="/magazzino" element={<WarehouseLayout onLogout={handleLogout} />} />
                    <Route path="*" element={<Navigate to="/magazzino" />} />
                </Routes>
            </Router>
        );
    }

    // Layout dedicato per gestore_automezzi: solo pagina Mezzi Disponibili Live, no sidebar
    if (role === "gestore_automezzi") {
        return (
            <Router>
                <Routes>
                    <Route path="/mezzi-disponibili-live" element={<AutomezziLayout onLogout={handleLogout} />} />
                    <Route path="*" element={<Navigate to="/mezzi-disponibili-live" />} />
                </Routes>
            </Router>
        );
    }

    return (
        <Router>
            <AuthenticatedLayout onLogout={handleLogout}>
                <PageErrorBoundary>
                <Routes>
                    {/* Home e sezioni principali */}
                    <Route path="/" element={<Home />} />
                    <Route path="/reportistica" element={<Reportistica />} />
                    <Route path="/automazione" element={<Automazione />} />
                    <Route path="/produttivita" element={<Produttivita />} />
                    <Route path="/ai-agents" element={<AIAgents />} />
                    <Route path="/applicativi" element={<Applicativi />} />

                    {/* Route card dinamiche basate sui permessi */}
                    {allowedRoutes.map(route => {
                        const Component = ROUTE_COMPONENTS[route];
                        return Component ? <Route key={route} path={route} element={<Component />} /> : null;
                    })}

                    {/* Amministrazione - hardcoded per sicurezza */}
                    {isAdmin && (
                        <>
                            <Route path="/upload" element={<Upload />} />
                            <Route path="/gestione-utenti" element={<GestioneUtenti />} />
                        </>
                    )}

                    {/* Materiali grafici del chatbot (task 453): sotto-pagina del chatbot, stesso
                        permesso (ai_agents.chatbot). Non è una card, quindi non sta in allowedRoutes:
                        si accende insieme alla route del chatbot. Il backend ricontrolla il permesso. */}
                    {allowedRoutes.includes("/chatbot-ai") && (
                        <Route path="/chatbot-ai/materiali" element={<MaterialiGrafici />} />
                    )}

                    {/* L'Anagrafica del Report Capisquadra (task 417) ora è una tab della pagina
                        (task 500): il vecchio indirizzo porta lì, così i link salvati funzionano. */}
                    {allowedRoutes.includes("/report-sap-capisquadra") && (
                        <Route path="/report-sap-capisquadra/anagrafica" element={<Navigate to="/report-sap-capisquadra?tab=anagrafica" replace />} />
                    )}

                    <Route path="*" element={<Navigate to={getDefaultRouteForRole(role)} />} />
                </Routes>
                </PageErrorBoundary>
            </AuthenticatedLayout>
        </Router>
    );
};

export default App;
